// source: acompanha/printer_models/v1/printer_models.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js');
goog.object.extend(proto, acompanha_common_v1_common_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.acompanha.printer_models.v1.CreatePrinterModelRequest', null, global);
goog.exportSymbol('proto.acompanha.printer_models.v1.CreatePrinterModelResponse', null, global);
goog.exportSymbol('proto.acompanha.printer_models.v1.DeletePrinterModelRequest', null, global);
goog.exportSymbol('proto.acompanha.printer_models.v1.GetPrinterModelRequest', null, global);
goog.exportSymbol('proto.acompanha.printer_models.v1.GetPrinterModelResponse', null, global);
goog.exportSymbol('proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesRequest', null, global);
goog.exportSymbol('proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesResponse', null, global);
goog.exportSymbol('proto.acompanha.printer_models.v1.ListPrinterModelsRequest', null, global);
goog.exportSymbol('proto.acompanha.printer_models.v1.ListPrinterModelsResponse', null, global);
goog.exportSymbol('proto.acompanha.printer_models.v1.MaintenanceTask', null, global);
goog.exportSymbol('proto.acompanha.printer_models.v1.MaintenanceTaskType', null, global);
goog.exportSymbol('proto.acompanha.printer_models.v1.PrinterModel', null, global);
goog.exportSymbol('proto.acompanha.printer_models.v1.PrinterModelsStats', null, global);
goog.exportSymbol('proto.acompanha.printer_models.v1.UpdatePrinterModelRequest', null, global);
goog.exportSymbol('proto.acompanha.printer_models.v1.UpdatePrinterModelResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printer_models.v1.MaintenanceTaskType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.printer_models.v1.MaintenanceTaskType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printer_models.v1.MaintenanceTaskType.displayName = 'proto.acompanha.printer_models.v1.MaintenanceTaskType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printer_models.v1.MaintenanceTask = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.printer_models.v1.MaintenanceTask, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printer_models.v1.MaintenanceTask.displayName = 'proto.acompanha.printer_models.v1.MaintenanceTask';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesRequest.displayName = 'proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesResponse.displayName = 'proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printer_models.v1.PrinterModel = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.printer_models.v1.PrinterModel.repeatedFields_, null);
};
goog.inherits(proto.acompanha.printer_models.v1.PrinterModel, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printer_models.v1.PrinterModel.displayName = 'proto.acompanha.printer_models.v1.PrinterModel';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printer_models.v1.PrinterModelsStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.printer_models.v1.PrinterModelsStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printer_models.v1.PrinterModelsStats.displayName = 'proto.acompanha.printer_models.v1.PrinterModelsStats';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printer_models.v1.ListPrinterModelsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.printer_models.v1.ListPrinterModelsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printer_models.v1.ListPrinterModelsRequest.displayName = 'proto.acompanha.printer_models.v1.ListPrinterModelsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printer_models.v1.ListPrinterModelsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.printer_models.v1.ListPrinterModelsResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.printer_models.v1.ListPrinterModelsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printer_models.v1.ListPrinterModelsResponse.displayName = 'proto.acompanha.printer_models.v1.ListPrinterModelsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printer_models.v1.GetPrinterModelRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.printer_models.v1.GetPrinterModelRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printer_models.v1.GetPrinterModelRequest.displayName = 'proto.acompanha.printer_models.v1.GetPrinterModelRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printer_models.v1.GetPrinterModelResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.printer_models.v1.GetPrinterModelResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printer_models.v1.GetPrinterModelResponse.displayName = 'proto.acompanha.printer_models.v1.GetPrinterModelResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printer_models.v1.CreatePrinterModelRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.printer_models.v1.CreatePrinterModelRequest.repeatedFields_, null);
};
goog.inherits(proto.acompanha.printer_models.v1.CreatePrinterModelRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printer_models.v1.CreatePrinterModelRequest.displayName = 'proto.acompanha.printer_models.v1.CreatePrinterModelRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printer_models.v1.CreatePrinterModelResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.printer_models.v1.CreatePrinterModelResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printer_models.v1.CreatePrinterModelResponse.displayName = 'proto.acompanha.printer_models.v1.CreatePrinterModelResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printer_models.v1.UpdatePrinterModelRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.printer_models.v1.UpdatePrinterModelRequest.repeatedFields_, null);
};
goog.inherits(proto.acompanha.printer_models.v1.UpdatePrinterModelRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printer_models.v1.UpdatePrinterModelRequest.displayName = 'proto.acompanha.printer_models.v1.UpdatePrinterModelRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printer_models.v1.UpdatePrinterModelResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.printer_models.v1.UpdatePrinterModelResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printer_models.v1.UpdatePrinterModelResponse.displayName = 'proto.acompanha.printer_models.v1.UpdatePrinterModelResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printer_models.v1.DeletePrinterModelRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.printer_models.v1.DeletePrinterModelRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printer_models.v1.DeletePrinterModelRequest.displayName = 'proto.acompanha.printer_models.v1.DeletePrinterModelRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printer_models.v1.MaintenanceTaskType.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printer_models.v1.MaintenanceTaskType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printer_models.v1.MaintenanceTaskType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_models.v1.MaintenanceTaskType.toObject = function(includeInstance, msg) {
  var f, obj = {
key: jspb.Message.getFieldWithDefault(msg, 1, ""),
label: jspb.Message.getFieldWithDefault(msg, 2, ""),
description: jspb.Message.getFieldWithDefault(msg, 3, ""),
defaultIntervalHours: jspb.Message.getFieldWithDefault(msg, 4, 0),
defaultIntervalDays: jspb.Message.getFieldWithDefault(msg, 5, 0),
sortOrder: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printer_models.v1.MaintenanceTaskType}
 */
proto.acompanha.printer_models.v1.MaintenanceTaskType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printer_models.v1.MaintenanceTaskType;
  return proto.acompanha.printer_models.v1.MaintenanceTaskType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printer_models.v1.MaintenanceTaskType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printer_models.v1.MaintenanceTaskType}
 */
proto.acompanha.printer_models.v1.MaintenanceTaskType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDefaultIntervalHours(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDefaultIntervalDays(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSortOrder(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printer_models.v1.MaintenanceTaskType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printer_models.v1.MaintenanceTaskType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printer_models.v1.MaintenanceTaskType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_models.v1.MaintenanceTaskType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDefaultIntervalHours();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getDefaultIntervalDays();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getSortOrder();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * optional string key = 1;
 * @return {string}
 */
proto.acompanha.printer_models.v1.MaintenanceTaskType.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_models.v1.MaintenanceTaskType} returns this
 */
proto.acompanha.printer_models.v1.MaintenanceTaskType.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string label = 2;
 * @return {string}
 */
proto.acompanha.printer_models.v1.MaintenanceTaskType.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_models.v1.MaintenanceTaskType} returns this
 */
proto.acompanha.printer_models.v1.MaintenanceTaskType.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.acompanha.printer_models.v1.MaintenanceTaskType.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_models.v1.MaintenanceTaskType} returns this
 */
proto.acompanha.printer_models.v1.MaintenanceTaskType.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 default_interval_hours = 4;
 * @return {number}
 */
proto.acompanha.printer_models.v1.MaintenanceTaskType.prototype.getDefaultIntervalHours = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_models.v1.MaintenanceTaskType} returns this
 */
proto.acompanha.printer_models.v1.MaintenanceTaskType.prototype.setDefaultIntervalHours = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 default_interval_days = 5;
 * @return {number}
 */
proto.acompanha.printer_models.v1.MaintenanceTaskType.prototype.getDefaultIntervalDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_models.v1.MaintenanceTaskType} returns this
 */
proto.acompanha.printer_models.v1.MaintenanceTaskType.prototype.setDefaultIntervalDays = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 sort_order = 6;
 * @return {number}
 */
proto.acompanha.printer_models.v1.MaintenanceTaskType.prototype.getSortOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_models.v1.MaintenanceTaskType} returns this
 */
proto.acompanha.printer_models.v1.MaintenanceTaskType.prototype.setSortOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printer_models.v1.MaintenanceTask.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printer_models.v1.MaintenanceTask.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printer_models.v1.MaintenanceTask} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_models.v1.MaintenanceTask.toObject = function(includeInstance, msg) {
  var f, obj = {
taskKey: jspb.Message.getFieldWithDefault(msg, 1, ""),
intervalHours: jspb.Message.getFieldWithDefault(msg, 2, 0),
intervalDays: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printer_models.v1.MaintenanceTask}
 */
proto.acompanha.printer_models.v1.MaintenanceTask.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printer_models.v1.MaintenanceTask;
  return proto.acompanha.printer_models.v1.MaintenanceTask.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printer_models.v1.MaintenanceTask} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printer_models.v1.MaintenanceTask}
 */
proto.acompanha.printer_models.v1.MaintenanceTask.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskKey(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIntervalHours(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIntervalDays(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printer_models.v1.MaintenanceTask.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printer_models.v1.MaintenanceTask.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printer_models.v1.MaintenanceTask} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_models.v1.MaintenanceTask.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaskKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIntervalHours();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getIntervalDays();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string task_key = 1;
 * @return {string}
 */
proto.acompanha.printer_models.v1.MaintenanceTask.prototype.getTaskKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_models.v1.MaintenanceTask} returns this
 */
proto.acompanha.printer_models.v1.MaintenanceTask.prototype.setTaskKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 interval_hours = 2;
 * @return {number}
 */
proto.acompanha.printer_models.v1.MaintenanceTask.prototype.getIntervalHours = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_models.v1.MaintenanceTask} returns this
 */
proto.acompanha.printer_models.v1.MaintenanceTask.prototype.setIntervalHours = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 interval_days = 3;
 * @return {number}
 */
proto.acompanha.printer_models.v1.MaintenanceTask.prototype.getIntervalDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_models.v1.MaintenanceTask} returns this
 */
proto.acompanha.printer_models.v1.MaintenanceTask.prototype.setIntervalDays = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesRequest}
 */
proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesRequest;
  return proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesRequest}
 */
proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.acompanha.printer_models.v1.MaintenanceTaskType.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesResponse}
 */
proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesResponse;
  return proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesResponse}
 */
proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.printer_models.v1.MaintenanceTaskType;
      reader.readMessage(value,proto.acompanha.printer_models.v1.MaintenanceTaskType.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.acompanha.printer_models.v1.MaintenanceTaskType.serializeBinaryToWriter
    );
  }
};


/**
 * repeated MaintenanceTaskType items = 1;
 * @return {!Array<!proto.acompanha.printer_models.v1.MaintenanceTaskType>}
 */
proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.acompanha.printer_models.v1.MaintenanceTaskType>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.printer_models.v1.MaintenanceTaskType, 1));
};


/**
 * @param {!Array<!proto.acompanha.printer_models.v1.MaintenanceTaskType>} value
 * @return {!proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesResponse} returns this
*/
proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.acompanha.printer_models.v1.MaintenanceTaskType=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.printer_models.v1.MaintenanceTaskType}
 */
proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.acompanha.printer_models.v1.MaintenanceTaskType, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesResponse} returns this
 */
proto.acompanha.printer_models.v1.ListMaintenanceTaskTypesResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.printer_models.v1.PrinterModel.repeatedFields_ = [11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printer_models.v1.PrinterModel.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printer_models.v1.PrinterModel.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printer_models.v1.PrinterModel} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_models.v1.PrinterModel.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
uuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
brand: jspb.Message.getFieldWithDefault(msg, 3, ""),
model: jspb.Message.getFieldWithDefault(msg, 4, ""),
avgConsumptionWatts: jspb.Message.getFieldWithDefault(msg, 5, 0),
maxConsumptionWatts: jspb.Message.getFieldWithDefault(msg, 6, 0),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
farmLinkSupported: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
experimental: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
maintenanceTasksList: jspb.Message.toObjectList(msg.getMaintenanceTasksList(),
    proto.acompanha.printer_models.v1.MaintenanceTask.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printer_models.v1.PrinterModel}
 */
proto.acompanha.printer_models.v1.PrinterModel.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printer_models.v1.PrinterModel;
  return proto.acompanha.printer_models.v1.PrinterModel.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printer_models.v1.PrinterModel} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printer_models.v1.PrinterModel}
 */
proto.acompanha.printer_models.v1.PrinterModel.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrand(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setModel(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAvgConsumptionWatts(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxConsumptionWatts(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFarmLinkSupported(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExperimental(value);
      break;
    case 11:
      var value = new proto.acompanha.printer_models.v1.MaintenanceTask;
      reader.readMessage(value,proto.acompanha.printer_models.v1.MaintenanceTask.deserializeBinaryFromReader);
      msg.addMaintenanceTasks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printer_models.v1.PrinterModel.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printer_models.v1.PrinterModel.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printer_models.v1.PrinterModel} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_models.v1.PrinterModel.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBrand();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getModel();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAvgConsumptionWatts();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getMaxConsumptionWatts();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getFarmLinkSupported();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getExperimental();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getMaintenanceTasksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      11,
      f,
      proto.acompanha.printer_models.v1.MaintenanceTask.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.acompanha.printer_models.v1.PrinterModel.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_models.v1.PrinterModel} returns this
 */
proto.acompanha.printer_models.v1.PrinterModel.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string uuid = 2;
 * @return {string}
 */
proto.acompanha.printer_models.v1.PrinterModel.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_models.v1.PrinterModel} returns this
 */
proto.acompanha.printer_models.v1.PrinterModel.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string brand = 3;
 * @return {string}
 */
proto.acompanha.printer_models.v1.PrinterModel.prototype.getBrand = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_models.v1.PrinterModel} returns this
 */
proto.acompanha.printer_models.v1.PrinterModel.prototype.setBrand = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string model = 4;
 * @return {string}
 */
proto.acompanha.printer_models.v1.PrinterModel.prototype.getModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_models.v1.PrinterModel} returns this
 */
proto.acompanha.printer_models.v1.PrinterModel.prototype.setModel = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 avg_consumption_watts = 5;
 * @return {number}
 */
proto.acompanha.printer_models.v1.PrinterModel.prototype.getAvgConsumptionWatts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_models.v1.PrinterModel} returns this
 */
proto.acompanha.printer_models.v1.PrinterModel.prototype.setAvgConsumptionWatts = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 max_consumption_watts = 6;
 * @return {number}
 */
proto.acompanha.printer_models.v1.PrinterModel.prototype.getMaxConsumptionWatts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_models.v1.PrinterModel} returns this
 */
proto.acompanha.printer_models.v1.PrinterModel.prototype.setMaxConsumptionWatts = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.printer_models.v1.PrinterModel.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.printer_models.v1.PrinterModel} returns this
*/
proto.acompanha.printer_models.v1.PrinterModel.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printer_models.v1.PrinterModel} returns this
 */
proto.acompanha.printer_models.v1.PrinterModel.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printer_models.v1.PrinterModel.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.printer_models.v1.PrinterModel.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.printer_models.v1.PrinterModel} returns this
*/
proto.acompanha.printer_models.v1.PrinterModel.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printer_models.v1.PrinterModel} returns this
 */
proto.acompanha.printer_models.v1.PrinterModel.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printer_models.v1.PrinterModel.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional bool farm_link_supported = 9;
 * @return {boolean}
 */
proto.acompanha.printer_models.v1.PrinterModel.prototype.getFarmLinkSupported = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.printer_models.v1.PrinterModel} returns this
 */
proto.acompanha.printer_models.v1.PrinterModel.prototype.setFarmLinkSupported = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional bool experimental = 10;
 * @return {boolean}
 */
proto.acompanha.printer_models.v1.PrinterModel.prototype.getExperimental = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.printer_models.v1.PrinterModel} returns this
 */
proto.acompanha.printer_models.v1.PrinterModel.prototype.setExperimental = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * repeated MaintenanceTask maintenance_tasks = 11;
 * @return {!Array<!proto.acompanha.printer_models.v1.MaintenanceTask>}
 */
proto.acompanha.printer_models.v1.PrinterModel.prototype.getMaintenanceTasksList = function() {
  return /** @type{!Array<!proto.acompanha.printer_models.v1.MaintenanceTask>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.printer_models.v1.MaintenanceTask, 11));
};


/**
 * @param {!Array<!proto.acompanha.printer_models.v1.MaintenanceTask>} value
 * @return {!proto.acompanha.printer_models.v1.PrinterModel} returns this
*/
proto.acompanha.printer_models.v1.PrinterModel.prototype.setMaintenanceTasksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 11, value);
};


/**
 * @param {!proto.acompanha.printer_models.v1.MaintenanceTask=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.printer_models.v1.MaintenanceTask}
 */
proto.acompanha.printer_models.v1.PrinterModel.prototype.addMaintenanceTasks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.acompanha.printer_models.v1.MaintenanceTask, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.printer_models.v1.PrinterModel} returns this
 */
proto.acompanha.printer_models.v1.PrinterModel.prototype.clearMaintenanceTasksList = function() {
  return this.setMaintenanceTasksList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printer_models.v1.PrinterModelsStats.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printer_models.v1.PrinterModelsStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printer_models.v1.PrinterModelsStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_models.v1.PrinterModelsStats.toObject = function(includeInstance, msg) {
  var f, obj = {
totalModels: jspb.Message.getFieldWithDefault(msg, 1, 0),
totalBrands: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printer_models.v1.PrinterModelsStats}
 */
proto.acompanha.printer_models.v1.PrinterModelsStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printer_models.v1.PrinterModelsStats;
  return proto.acompanha.printer_models.v1.PrinterModelsStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printer_models.v1.PrinterModelsStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printer_models.v1.PrinterModelsStats}
 */
proto.acompanha.printer_models.v1.PrinterModelsStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalModels(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalBrands(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printer_models.v1.PrinterModelsStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printer_models.v1.PrinterModelsStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printer_models.v1.PrinterModelsStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_models.v1.PrinterModelsStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalModels();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTotalBrands();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 total_models = 1;
 * @return {number}
 */
proto.acompanha.printer_models.v1.PrinterModelsStats.prototype.getTotalModels = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_models.v1.PrinterModelsStats} returns this
 */
proto.acompanha.printer_models.v1.PrinterModelsStats.prototype.setTotalModels = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 total_brands = 2;
 * @return {number}
 */
proto.acompanha.printer_models.v1.PrinterModelsStats.prototype.getTotalBrands = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_models.v1.PrinterModelsStats} returns this
 */
proto.acompanha.printer_models.v1.PrinterModelsStats.prototype.setTotalBrands = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printer_models.v1.ListPrinterModelsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printer_models.v1.ListPrinterModelsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printer_models.v1.ListPrinterModelsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_models.v1.ListPrinterModelsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
pagination: (f = msg.getPagination()) && acompanha_common_v1_common_pb.PaginationRequest.toObject(includeInstance, f),
brand: jspb.Message.getFieldWithDefault(msg, 2, ""),
farmLinkSupport: jspb.Message.getFieldWithDefault(msg, 3, ""),
experimental: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printer_models.v1.ListPrinterModelsRequest}
 */
proto.acompanha.printer_models.v1.ListPrinterModelsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printer_models.v1.ListPrinterModelsRequest;
  return proto.acompanha.printer_models.v1.ListPrinterModelsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printer_models.v1.ListPrinterModelsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printer_models.v1.ListPrinterModelsRequest}
 */
proto.acompanha.printer_models.v1.ListPrinterModelsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new acompanha_common_v1_common_pb.PaginationRequest;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaginationRequest.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrand(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFarmLinkSupport(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setExperimental(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printer_models.v1.ListPrinterModelsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printer_models.v1.ListPrinterModelsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printer_models.v1.ListPrinterModelsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_models.v1.ListPrinterModelsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      acompanha_common_v1_common_pb.PaginationRequest.serializeBinaryToWriter
    );
  }
  f = message.getBrand();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFarmLinkSupport();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getExperimental();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional acompanha.common.v1.PaginationRequest pagination = 1;
 * @return {?proto.acompanha.common.v1.PaginationRequest}
 */
proto.acompanha.printer_models.v1.ListPrinterModelsRequest.prototype.getPagination = function() {
  return /** @type{?proto.acompanha.common.v1.PaginationRequest} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaginationRequest, 1));
};


/**
 * @param {?proto.acompanha.common.v1.PaginationRequest|undefined} value
 * @return {!proto.acompanha.printer_models.v1.ListPrinterModelsRequest} returns this
*/
proto.acompanha.printer_models.v1.ListPrinterModelsRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printer_models.v1.ListPrinterModelsRequest} returns this
 */
proto.acompanha.printer_models.v1.ListPrinterModelsRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printer_models.v1.ListPrinterModelsRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string brand = 2;
 * @return {string}
 */
proto.acompanha.printer_models.v1.ListPrinterModelsRequest.prototype.getBrand = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_models.v1.ListPrinterModelsRequest} returns this
 */
proto.acompanha.printer_models.v1.ListPrinterModelsRequest.prototype.setBrand = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string farm_link_support = 3;
 * @return {string}
 */
proto.acompanha.printer_models.v1.ListPrinterModelsRequest.prototype.getFarmLinkSupport = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_models.v1.ListPrinterModelsRequest} returns this
 */
proto.acompanha.printer_models.v1.ListPrinterModelsRequest.prototype.setFarmLinkSupport = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string experimental = 4;
 * @return {string}
 */
proto.acompanha.printer_models.v1.ListPrinterModelsRequest.prototype.getExperimental = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_models.v1.ListPrinterModelsRequest} returns this
 */
proto.acompanha.printer_models.v1.ListPrinterModelsRequest.prototype.setExperimental = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.printer_models.v1.ListPrinterModelsResponse.repeatedFields_ = [1,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printer_models.v1.ListPrinterModelsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printer_models.v1.ListPrinterModelsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printer_models.v1.ListPrinterModelsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_models.v1.ListPrinterModelsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.acompanha.printer_models.v1.PrinterModel.toObject, includeInstance),
meta: (f = msg.getMeta()) && acompanha_common_v1_common_pb.PaginationMeta.toObject(includeInstance, f),
stats: (f = msg.getStats()) && proto.acompanha.printer_models.v1.PrinterModelsStats.toObject(includeInstance, f),
brandsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printer_models.v1.ListPrinterModelsResponse}
 */
proto.acompanha.printer_models.v1.ListPrinterModelsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printer_models.v1.ListPrinterModelsResponse;
  return proto.acompanha.printer_models.v1.ListPrinterModelsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printer_models.v1.ListPrinterModelsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printer_models.v1.ListPrinterModelsResponse}
 */
proto.acompanha.printer_models.v1.ListPrinterModelsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.printer_models.v1.PrinterModel;
      reader.readMessage(value,proto.acompanha.printer_models.v1.PrinterModel.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 2:
      var value = new acompanha_common_v1_common_pb.PaginationMeta;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaginationMeta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    case 3:
      var value = new proto.acompanha.printer_models.v1.PrinterModelsStats;
      reader.readMessage(value,proto.acompanha.printer_models.v1.PrinterModelsStats.deserializeBinaryFromReader);
      msg.setStats(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addBrands(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printer_models.v1.ListPrinterModelsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printer_models.v1.ListPrinterModelsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printer_models.v1.ListPrinterModelsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_models.v1.ListPrinterModelsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.acompanha.printer_models.v1.PrinterModel.serializeBinaryToWriter
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      acompanha_common_v1_common_pb.PaginationMeta.serializeBinaryToWriter
    );
  }
  f = message.getStats();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.acompanha.printer_models.v1.PrinterModelsStats.serializeBinaryToWriter
    );
  }
  f = message.getBrandsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
};


/**
 * repeated PrinterModel items = 1;
 * @return {!Array<!proto.acompanha.printer_models.v1.PrinterModel>}
 */
proto.acompanha.printer_models.v1.ListPrinterModelsResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.acompanha.printer_models.v1.PrinterModel>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.printer_models.v1.PrinterModel, 1));
};


/**
 * @param {!Array<!proto.acompanha.printer_models.v1.PrinterModel>} value
 * @return {!proto.acompanha.printer_models.v1.ListPrinterModelsResponse} returns this
*/
proto.acompanha.printer_models.v1.ListPrinterModelsResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.acompanha.printer_models.v1.PrinterModel=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.printer_models.v1.PrinterModel}
 */
proto.acompanha.printer_models.v1.ListPrinterModelsResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.acompanha.printer_models.v1.PrinterModel, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.printer_models.v1.ListPrinterModelsResponse} returns this
 */
proto.acompanha.printer_models.v1.ListPrinterModelsResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional acompanha.common.v1.PaginationMeta meta = 2;
 * @return {?proto.acompanha.common.v1.PaginationMeta}
 */
proto.acompanha.printer_models.v1.ListPrinterModelsResponse.prototype.getMeta = function() {
  return /** @type{?proto.acompanha.common.v1.PaginationMeta} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaginationMeta, 2));
};


/**
 * @param {?proto.acompanha.common.v1.PaginationMeta|undefined} value
 * @return {!proto.acompanha.printer_models.v1.ListPrinterModelsResponse} returns this
*/
proto.acompanha.printer_models.v1.ListPrinterModelsResponse.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printer_models.v1.ListPrinterModelsResponse} returns this
 */
proto.acompanha.printer_models.v1.ListPrinterModelsResponse.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printer_models.v1.ListPrinterModelsResponse.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional PrinterModelsStats stats = 3;
 * @return {?proto.acompanha.printer_models.v1.PrinterModelsStats}
 */
proto.acompanha.printer_models.v1.ListPrinterModelsResponse.prototype.getStats = function() {
  return /** @type{?proto.acompanha.printer_models.v1.PrinterModelsStats} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.printer_models.v1.PrinterModelsStats, 3));
};


/**
 * @param {?proto.acompanha.printer_models.v1.PrinterModelsStats|undefined} value
 * @return {!proto.acompanha.printer_models.v1.ListPrinterModelsResponse} returns this
*/
proto.acompanha.printer_models.v1.ListPrinterModelsResponse.prototype.setStats = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printer_models.v1.ListPrinterModelsResponse} returns this
 */
proto.acompanha.printer_models.v1.ListPrinterModelsResponse.prototype.clearStats = function() {
  return this.setStats(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printer_models.v1.ListPrinterModelsResponse.prototype.hasStats = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated string brands = 4;
 * @return {!Array<string>}
 */
proto.acompanha.printer_models.v1.ListPrinterModelsResponse.prototype.getBrandsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.acompanha.printer_models.v1.ListPrinterModelsResponse} returns this
 */
proto.acompanha.printer_models.v1.ListPrinterModelsResponse.prototype.setBrandsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.acompanha.printer_models.v1.ListPrinterModelsResponse} returns this
 */
proto.acompanha.printer_models.v1.ListPrinterModelsResponse.prototype.addBrands = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.printer_models.v1.ListPrinterModelsResponse} returns this
 */
proto.acompanha.printer_models.v1.ListPrinterModelsResponse.prototype.clearBrandsList = function() {
  return this.setBrandsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printer_models.v1.GetPrinterModelRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printer_models.v1.GetPrinterModelRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printer_models.v1.GetPrinterModelRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_models.v1.GetPrinterModelRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printer_models.v1.GetPrinterModelRequest}
 */
proto.acompanha.printer_models.v1.GetPrinterModelRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printer_models.v1.GetPrinterModelRequest;
  return proto.acompanha.printer_models.v1.GetPrinterModelRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printer_models.v1.GetPrinterModelRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printer_models.v1.GetPrinterModelRequest}
 */
proto.acompanha.printer_models.v1.GetPrinterModelRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printer_models.v1.GetPrinterModelRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printer_models.v1.GetPrinterModelRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printer_models.v1.GetPrinterModelRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_models.v1.GetPrinterModelRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.printer_models.v1.GetPrinterModelRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_models.v1.GetPrinterModelRequest} returns this
 */
proto.acompanha.printer_models.v1.GetPrinterModelRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printer_models.v1.GetPrinterModelResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printer_models.v1.GetPrinterModelResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printer_models.v1.GetPrinterModelResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_models.v1.GetPrinterModelResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.printer_models.v1.PrinterModel.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printer_models.v1.GetPrinterModelResponse}
 */
proto.acompanha.printer_models.v1.GetPrinterModelResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printer_models.v1.GetPrinterModelResponse;
  return proto.acompanha.printer_models.v1.GetPrinterModelResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printer_models.v1.GetPrinterModelResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printer_models.v1.GetPrinterModelResponse}
 */
proto.acompanha.printer_models.v1.GetPrinterModelResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.printer_models.v1.PrinterModel;
      reader.readMessage(value,proto.acompanha.printer_models.v1.PrinterModel.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printer_models.v1.GetPrinterModelResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printer_models.v1.GetPrinterModelResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printer_models.v1.GetPrinterModelResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_models.v1.GetPrinterModelResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.printer_models.v1.PrinterModel.serializeBinaryToWriter
    );
  }
};


/**
 * optional PrinterModel data = 1;
 * @return {?proto.acompanha.printer_models.v1.PrinterModel}
 */
proto.acompanha.printer_models.v1.GetPrinterModelResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.printer_models.v1.PrinterModel} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.printer_models.v1.PrinterModel, 1));
};


/**
 * @param {?proto.acompanha.printer_models.v1.PrinterModel|undefined} value
 * @return {!proto.acompanha.printer_models.v1.GetPrinterModelResponse} returns this
*/
proto.acompanha.printer_models.v1.GetPrinterModelResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printer_models.v1.GetPrinterModelResponse} returns this
 */
proto.acompanha.printer_models.v1.GetPrinterModelResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printer_models.v1.GetPrinterModelResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.printer_models.v1.CreatePrinterModelRequest.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printer_models.v1.CreatePrinterModelRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printer_models.v1.CreatePrinterModelRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printer_models.v1.CreatePrinterModelRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_models.v1.CreatePrinterModelRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
brand: jspb.Message.getFieldWithDefault(msg, 1, ""),
model: jspb.Message.getFieldWithDefault(msg, 2, ""),
avgConsumptionWatts: jspb.Message.getFieldWithDefault(msg, 3, 0),
maxConsumptionWatts: jspb.Message.getFieldWithDefault(msg, 4, 0),
farmLinkSupported: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
experimental: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
maintenanceTasksList: jspb.Message.toObjectList(msg.getMaintenanceTasksList(),
    proto.acompanha.printer_models.v1.MaintenanceTask.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printer_models.v1.CreatePrinterModelRequest}
 */
proto.acompanha.printer_models.v1.CreatePrinterModelRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printer_models.v1.CreatePrinterModelRequest;
  return proto.acompanha.printer_models.v1.CreatePrinterModelRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printer_models.v1.CreatePrinterModelRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printer_models.v1.CreatePrinterModelRequest}
 */
proto.acompanha.printer_models.v1.CreatePrinterModelRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrand(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setModel(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAvgConsumptionWatts(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxConsumptionWatts(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFarmLinkSupported(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExperimental(value);
      break;
    case 7:
      var value = new proto.acompanha.printer_models.v1.MaintenanceTask;
      reader.readMessage(value,proto.acompanha.printer_models.v1.MaintenanceTask.deserializeBinaryFromReader);
      msg.addMaintenanceTasks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printer_models.v1.CreatePrinterModelRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printer_models.v1.CreatePrinterModelRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printer_models.v1.CreatePrinterModelRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_models.v1.CreatePrinterModelRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrand();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getModel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAvgConsumptionWatts();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getMaxConsumptionWatts();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getFarmLinkSupported();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getExperimental();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getMaintenanceTasksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.acompanha.printer_models.v1.MaintenanceTask.serializeBinaryToWriter
    );
  }
};


/**
 * optional string brand = 1;
 * @return {string}
 */
proto.acompanha.printer_models.v1.CreatePrinterModelRequest.prototype.getBrand = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_models.v1.CreatePrinterModelRequest} returns this
 */
proto.acompanha.printer_models.v1.CreatePrinterModelRequest.prototype.setBrand = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string model = 2;
 * @return {string}
 */
proto.acompanha.printer_models.v1.CreatePrinterModelRequest.prototype.getModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_models.v1.CreatePrinterModelRequest} returns this
 */
proto.acompanha.printer_models.v1.CreatePrinterModelRequest.prototype.setModel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 avg_consumption_watts = 3;
 * @return {number}
 */
proto.acompanha.printer_models.v1.CreatePrinterModelRequest.prototype.getAvgConsumptionWatts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_models.v1.CreatePrinterModelRequest} returns this
 */
proto.acompanha.printer_models.v1.CreatePrinterModelRequest.prototype.setAvgConsumptionWatts = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 max_consumption_watts = 4;
 * @return {number}
 */
proto.acompanha.printer_models.v1.CreatePrinterModelRequest.prototype.getMaxConsumptionWatts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_models.v1.CreatePrinterModelRequest} returns this
 */
proto.acompanha.printer_models.v1.CreatePrinterModelRequest.prototype.setMaxConsumptionWatts = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional bool farm_link_supported = 5;
 * @return {boolean}
 */
proto.acompanha.printer_models.v1.CreatePrinterModelRequest.prototype.getFarmLinkSupported = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.printer_models.v1.CreatePrinterModelRequest} returns this
 */
proto.acompanha.printer_models.v1.CreatePrinterModelRequest.prototype.setFarmLinkSupported = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool experimental = 6;
 * @return {boolean}
 */
proto.acompanha.printer_models.v1.CreatePrinterModelRequest.prototype.getExperimental = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.printer_models.v1.CreatePrinterModelRequest} returns this
 */
proto.acompanha.printer_models.v1.CreatePrinterModelRequest.prototype.setExperimental = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * repeated MaintenanceTask maintenance_tasks = 7;
 * @return {!Array<!proto.acompanha.printer_models.v1.MaintenanceTask>}
 */
proto.acompanha.printer_models.v1.CreatePrinterModelRequest.prototype.getMaintenanceTasksList = function() {
  return /** @type{!Array<!proto.acompanha.printer_models.v1.MaintenanceTask>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.printer_models.v1.MaintenanceTask, 7));
};


/**
 * @param {!Array<!proto.acompanha.printer_models.v1.MaintenanceTask>} value
 * @return {!proto.acompanha.printer_models.v1.CreatePrinterModelRequest} returns this
*/
proto.acompanha.printer_models.v1.CreatePrinterModelRequest.prototype.setMaintenanceTasksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.acompanha.printer_models.v1.MaintenanceTask=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.printer_models.v1.MaintenanceTask}
 */
proto.acompanha.printer_models.v1.CreatePrinterModelRequest.prototype.addMaintenanceTasks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.acompanha.printer_models.v1.MaintenanceTask, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.printer_models.v1.CreatePrinterModelRequest} returns this
 */
proto.acompanha.printer_models.v1.CreatePrinterModelRequest.prototype.clearMaintenanceTasksList = function() {
  return this.setMaintenanceTasksList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printer_models.v1.CreatePrinterModelResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printer_models.v1.CreatePrinterModelResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printer_models.v1.CreatePrinterModelResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_models.v1.CreatePrinterModelResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.printer_models.v1.PrinterModel.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printer_models.v1.CreatePrinterModelResponse}
 */
proto.acompanha.printer_models.v1.CreatePrinterModelResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printer_models.v1.CreatePrinterModelResponse;
  return proto.acompanha.printer_models.v1.CreatePrinterModelResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printer_models.v1.CreatePrinterModelResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printer_models.v1.CreatePrinterModelResponse}
 */
proto.acompanha.printer_models.v1.CreatePrinterModelResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.printer_models.v1.PrinterModel;
      reader.readMessage(value,proto.acompanha.printer_models.v1.PrinterModel.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printer_models.v1.CreatePrinterModelResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printer_models.v1.CreatePrinterModelResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printer_models.v1.CreatePrinterModelResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_models.v1.CreatePrinterModelResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.printer_models.v1.PrinterModel.serializeBinaryToWriter
    );
  }
};


/**
 * optional PrinterModel data = 1;
 * @return {?proto.acompanha.printer_models.v1.PrinterModel}
 */
proto.acompanha.printer_models.v1.CreatePrinterModelResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.printer_models.v1.PrinterModel} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.printer_models.v1.PrinterModel, 1));
};


/**
 * @param {?proto.acompanha.printer_models.v1.PrinterModel|undefined} value
 * @return {!proto.acompanha.printer_models.v1.CreatePrinterModelResponse} returns this
*/
proto.acompanha.printer_models.v1.CreatePrinterModelResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printer_models.v1.CreatePrinterModelResponse} returns this
 */
proto.acompanha.printer_models.v1.CreatePrinterModelResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printer_models.v1.CreatePrinterModelResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.printer_models.v1.UpdatePrinterModelRequest.repeatedFields_ = [8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printer_models.v1.UpdatePrinterModelRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printer_models.v1.UpdatePrinterModelRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printer_models.v1.UpdatePrinterModelRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_models.v1.UpdatePrinterModelRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
brand: jspb.Message.getFieldWithDefault(msg, 2, ""),
model: jspb.Message.getFieldWithDefault(msg, 3, ""),
avgConsumptionWatts: jspb.Message.getFieldWithDefault(msg, 4, 0),
maxConsumptionWatts: jspb.Message.getFieldWithDefault(msg, 5, 0),
farmLinkSupported: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
experimental: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
maintenanceTasksList: jspb.Message.toObjectList(msg.getMaintenanceTasksList(),
    proto.acompanha.printer_models.v1.MaintenanceTask.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printer_models.v1.UpdatePrinterModelRequest}
 */
proto.acompanha.printer_models.v1.UpdatePrinterModelRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printer_models.v1.UpdatePrinterModelRequest;
  return proto.acompanha.printer_models.v1.UpdatePrinterModelRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printer_models.v1.UpdatePrinterModelRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printer_models.v1.UpdatePrinterModelRequest}
 */
proto.acompanha.printer_models.v1.UpdatePrinterModelRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrand(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setModel(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAvgConsumptionWatts(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxConsumptionWatts(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFarmLinkSupported(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExperimental(value);
      break;
    case 8:
      var value = new proto.acompanha.printer_models.v1.MaintenanceTask;
      reader.readMessage(value,proto.acompanha.printer_models.v1.MaintenanceTask.deserializeBinaryFromReader);
      msg.addMaintenanceTasks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printer_models.v1.UpdatePrinterModelRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printer_models.v1.UpdatePrinterModelRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printer_models.v1.UpdatePrinterModelRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_models.v1.UpdatePrinterModelRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBrand();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getModel();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAvgConsumptionWatts();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getMaxConsumptionWatts();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getFarmLinkSupported();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getExperimental();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getMaintenanceTasksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.acompanha.printer_models.v1.MaintenanceTask.serializeBinaryToWriter
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.printer_models.v1.UpdatePrinterModelRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_models.v1.UpdatePrinterModelRequest} returns this
 */
proto.acompanha.printer_models.v1.UpdatePrinterModelRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string brand = 2;
 * @return {string}
 */
proto.acompanha.printer_models.v1.UpdatePrinterModelRequest.prototype.getBrand = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_models.v1.UpdatePrinterModelRequest} returns this
 */
proto.acompanha.printer_models.v1.UpdatePrinterModelRequest.prototype.setBrand = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string model = 3;
 * @return {string}
 */
proto.acompanha.printer_models.v1.UpdatePrinterModelRequest.prototype.getModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_models.v1.UpdatePrinterModelRequest} returns this
 */
proto.acompanha.printer_models.v1.UpdatePrinterModelRequest.prototype.setModel = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 avg_consumption_watts = 4;
 * @return {number}
 */
proto.acompanha.printer_models.v1.UpdatePrinterModelRequest.prototype.getAvgConsumptionWatts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_models.v1.UpdatePrinterModelRequest} returns this
 */
proto.acompanha.printer_models.v1.UpdatePrinterModelRequest.prototype.setAvgConsumptionWatts = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 max_consumption_watts = 5;
 * @return {number}
 */
proto.acompanha.printer_models.v1.UpdatePrinterModelRequest.prototype.getMaxConsumptionWatts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_models.v1.UpdatePrinterModelRequest} returns this
 */
proto.acompanha.printer_models.v1.UpdatePrinterModelRequest.prototype.setMaxConsumptionWatts = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional bool farm_link_supported = 6;
 * @return {boolean}
 */
proto.acompanha.printer_models.v1.UpdatePrinterModelRequest.prototype.getFarmLinkSupported = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.printer_models.v1.UpdatePrinterModelRequest} returns this
 */
proto.acompanha.printer_models.v1.UpdatePrinterModelRequest.prototype.setFarmLinkSupported = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool experimental = 7;
 * @return {boolean}
 */
proto.acompanha.printer_models.v1.UpdatePrinterModelRequest.prototype.getExperimental = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.printer_models.v1.UpdatePrinterModelRequest} returns this
 */
proto.acompanha.printer_models.v1.UpdatePrinterModelRequest.prototype.setExperimental = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * repeated MaintenanceTask maintenance_tasks = 8;
 * @return {!Array<!proto.acompanha.printer_models.v1.MaintenanceTask>}
 */
proto.acompanha.printer_models.v1.UpdatePrinterModelRequest.prototype.getMaintenanceTasksList = function() {
  return /** @type{!Array<!proto.acompanha.printer_models.v1.MaintenanceTask>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.printer_models.v1.MaintenanceTask, 8));
};


/**
 * @param {!Array<!proto.acompanha.printer_models.v1.MaintenanceTask>} value
 * @return {!proto.acompanha.printer_models.v1.UpdatePrinterModelRequest} returns this
*/
proto.acompanha.printer_models.v1.UpdatePrinterModelRequest.prototype.setMaintenanceTasksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.acompanha.printer_models.v1.MaintenanceTask=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.printer_models.v1.MaintenanceTask}
 */
proto.acompanha.printer_models.v1.UpdatePrinterModelRequest.prototype.addMaintenanceTasks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.acompanha.printer_models.v1.MaintenanceTask, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.printer_models.v1.UpdatePrinterModelRequest} returns this
 */
proto.acompanha.printer_models.v1.UpdatePrinterModelRequest.prototype.clearMaintenanceTasksList = function() {
  return this.setMaintenanceTasksList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printer_models.v1.UpdatePrinterModelResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printer_models.v1.UpdatePrinterModelResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printer_models.v1.UpdatePrinterModelResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_models.v1.UpdatePrinterModelResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.printer_models.v1.PrinterModel.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printer_models.v1.UpdatePrinterModelResponse}
 */
proto.acompanha.printer_models.v1.UpdatePrinterModelResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printer_models.v1.UpdatePrinterModelResponse;
  return proto.acompanha.printer_models.v1.UpdatePrinterModelResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printer_models.v1.UpdatePrinterModelResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printer_models.v1.UpdatePrinterModelResponse}
 */
proto.acompanha.printer_models.v1.UpdatePrinterModelResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.printer_models.v1.PrinterModel;
      reader.readMessage(value,proto.acompanha.printer_models.v1.PrinterModel.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printer_models.v1.UpdatePrinterModelResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printer_models.v1.UpdatePrinterModelResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printer_models.v1.UpdatePrinterModelResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_models.v1.UpdatePrinterModelResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.printer_models.v1.PrinterModel.serializeBinaryToWriter
    );
  }
};


/**
 * optional PrinterModel data = 1;
 * @return {?proto.acompanha.printer_models.v1.PrinterModel}
 */
proto.acompanha.printer_models.v1.UpdatePrinterModelResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.printer_models.v1.PrinterModel} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.printer_models.v1.PrinterModel, 1));
};


/**
 * @param {?proto.acompanha.printer_models.v1.PrinterModel|undefined} value
 * @return {!proto.acompanha.printer_models.v1.UpdatePrinterModelResponse} returns this
*/
proto.acompanha.printer_models.v1.UpdatePrinterModelResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printer_models.v1.UpdatePrinterModelResponse} returns this
 */
proto.acompanha.printer_models.v1.UpdatePrinterModelResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printer_models.v1.UpdatePrinterModelResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printer_models.v1.DeletePrinterModelRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printer_models.v1.DeletePrinterModelRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printer_models.v1.DeletePrinterModelRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_models.v1.DeletePrinterModelRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printer_models.v1.DeletePrinterModelRequest}
 */
proto.acompanha.printer_models.v1.DeletePrinterModelRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printer_models.v1.DeletePrinterModelRequest;
  return proto.acompanha.printer_models.v1.DeletePrinterModelRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printer_models.v1.DeletePrinterModelRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printer_models.v1.DeletePrinterModelRequest}
 */
proto.acompanha.printer_models.v1.DeletePrinterModelRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printer_models.v1.DeletePrinterModelRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printer_models.v1.DeletePrinterModelRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printer_models.v1.DeletePrinterModelRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_models.v1.DeletePrinterModelRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.printer_models.v1.DeletePrinterModelRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_models.v1.DeletePrinterModelRequest} returns this
 */
proto.acompanha.printer_models.v1.DeletePrinterModelRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


goog.object.extend(exports, proto.acompanha.printer_models.v1);
